import { Injectable } from '@angular/core';
import { WritableSignal, signal } from '@angular/core';
import {TableRow, TableColumn} from '../../../shared/models/components/tables/table.models';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {   ProjectData } from '../../models/serviceModels/request/modelDefinitionsReq.model';
import {   projectInputsByModelResponse } from '../../models/serviceModels/response/model-definitions-response.models';
import {tradingStrategyResponse} from '../../models/serviceModels/response/trading-strategy-response.model';

import { TradingStrategyReqModel } from '../../models/serviceModels/request/tradingStrategyReq.model';

@Injectable({
    providedIn: 'root'
  })
  export class TradingStrategyService {


    predictionRange: Date[] | null = null;
    exclusionDateRanges: { start: Date, end: Date }[] = [];
    currentTradingStrategyResponse: tradingStrategyResponse | null = null;
    columnsAlltrades: TableColumn[]=[];

    constructor(private apiService: ApiService) { }

    runTradingStrategy(inputsRequest: TradingStrategyReqModel): Observable<tradingStrategyResponse> {
     
        return this.apiService.post('api/Data/RunTradingStrategy', inputsRequest);
    }

    setColumnsAllTrades(columns: TableColumn[]) {
        this.columnsAlltrades = columns;
    }

    getColumnsAllTrades(): TableColumn[] {  
        return this.columnsAlltrades;
    }

    setCurrentPredictionRange(dates: Date[] | null) {
      this.predictionRange = dates;
    }

    getCurrentPredictionRange(): Date[] | null {
        return this.predictionRange;
    }

    // getModelAccuracy(modelAccuracyModel: ModelAccuracyModel): Observable<modelAccuracyResponse> {
    //     return this.apiService.post('api/Data/GetModelAccuracy', modelAccuracyModel);
    //   }
     
  setExclusionDateRanges(ranges: { start: Date, end: Date }[]) {
      this.exclusionDateRanges = ranges;
  }

  getExclusionDateRanges(): { start: Date, end: Date }[] {
      return this.exclusionDateRanges;
  }

  setBackupTradingStrategyResponse(data: tradingStrategyResponse) {
    this.currentTradingStrategyResponse = data;
  }

  getBackupTradingStrategyResponse(): tradingStrategyResponse | null {
    return this.currentTradingStrategyResponse; 
  }
     
  }